import { Dispatch, Middleware, MiddlewareAPI } from "redux";
import IAction from "../models/IAction";
import UserAction from "stores/user/UserAction";
import ValidationUtility from "utilities/ValidationUtility";
import IStore from "models/IStore";

const cookieConsentMiddleware = (): Middleware => (store: MiddlewareAPI<Dispatch, IStore>) => (next: Dispatch) => (
    action: IAction<any>
): void => {
    if (store.getState().user.profile.isCookieAllowed === false) {
        const cookieValue = ValidationUtility.getCookie("ecq-cookie-consent");
        const consent = cookieValue === "true";
        if (consent === true) {
            next(UserAction.setCookieConsent(consent));
        }
    }

    next(action);
};

export default cookieConsentMiddleware;
